import { Dispatch, SetStateAction } from 'react';

import { Box, Button, SxProps } from '@mui/material';

import { ColunasDinamicasOpcoesFilter } from 'pages/cadastro/colunas-dinamicas/components/atoms/ColunasDinamicasOpcoesFilter';

type ConfiguracaoPedidoHeaderActions = {
    searchPlaceholder?: string;
    setValueFilter?: Dispatch<SetStateAction<string>>;
    onClickAdd: () => void;
    sx?: SxProps;
    showSearchField?: boolean;
    addDisabled?: boolean;
};

export function HeaderColunasOpcoes({ searchPlaceholder, setValueFilter = () => {}, onClickAdd, sx, addDisabled }: ConfiguracaoPedidoHeaderActions) {
    return (
        <Box
            sx={{
                gap: 2,
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                alignItems: 'center',
                justifyContent: 'normal',
                mb: 2,
                ...sx,
            }}
        >
            <ColunasDinamicasOpcoesFilter placeholder={searchPlaceholder} setValueFilter={setValueFilter} sx={{ mr: { xs: 'none', md: 'auto' } }} />

            <Button
                variant="contained"
                disabled={addDisabled}
                onClick={onClickAdd}
                sx={{
                    height: 33,
                    width: { xs: '100%', md: 'auto' },
                }}
            >
                Incluir
            </Button>
        </Box>
    );
}
